import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';

interface Payment {
  applicant_payment_id: number;
  vat_num: string;
  quarter_id: number;
  quarter: string;
  year: number;
  submission_date: string;
  amount: number;
  payment_date: string;
}

interface Paging {
  page: number;
  pageSize: number;
  total: number;
}
interface PaymentListData {
  paging: Paging;
  items: Payment[];
}

interface PaymentListOutput {
  status: StateStatus;
  data: PaymentListData | null;
}

export const useGetPaymentList = (): PaymentListOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.PAYMENT_LIST_REDUCER].paymentList
  );
  return data;
};

export const useGetPaymentInfoStatus = (): StateStatus => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.PAYMENT_LIST_REDUCER].paymentInfoStatus
  );
  return data;
};

interface IPaymentInfo {
  payment_info_id: number;
  country_id: number;
  country: string;
  amount_received: number;
}
interface PaymentInfoListData {
  items: IPaymentInfo[];
  paging: Paging;
}

// interface IPaymentInfoListInput {
//   sortField: string;
//   page: number;
//   pageSize: number;
//   order: 'asc' | 'desc';
// }

interface PaymentInfoListOutput {
  status: StateStatus;
  data: PaymentInfoListData | null;
}

export const useGetPaymentInfoList = (): PaymentInfoListOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.PAYMENT_LIST_REDUCER].paymentInfoList
  );
  return data;
};
